import {
  useGetEnergySource,
  useGetFertilizerData,
  useGetIrrigationMethod,
  useGetLandUsage,
  useGetPesticideData,
  useGetPowerSource,
  useGetProduceType
} from "../../../../api/static-data";

export const useCultivarStaticDataLoading = (): boolean => {
  const { isLoading: isProduceTypesLoading } = useGetProduceType();
  const { isLoading: isFertilizerLoading } = useGetFertilizerData();
  const { isLoading: isPesticideLoading } = useGetPesticideData();
  const { isLoading: isEnergySourceLoading } = useGetEnergySource();
  const { isLoading: isIrrigationLoading } = useGetIrrigationMethod();
  const { isLoading: isPowerSourceLoading } = useGetPowerSource();
  const { isLoading: isLandUsageLoading } = useGetLandUsage();

  return (
    isProduceTypesLoading ||
    isFertilizerLoading ||
    isPesticideLoading ||
    isEnergySourceLoading ||
    isIrrigationLoading ||
    isPowerSourceLoading ||
    isLandUsageLoading
  );
};
